// Ported from horizontal-actions-dashboard/frontend/src/utils/format.ts (verbatim logic).

export function formatPercent(pct: number | null | undefined): string {
  if (pct === null || pct === undefined) return '—';
  return `${pct.toFixed(1)}%`;
}

// Internal key stays "not_started" for API/wire-format stability; displayed label is
// "Not Reviewed" per data-owner request.
export const STATUS_LABELS: Record<string, string> = {
  completed: 'Completed',
  in_progress: 'In progress',
  not_started: 'Not Reviewed',
  blocked_or_attention: 'Blocked / needs attention',
  unknown: 'Unknown — needs review',
};

// Lowercase filter-option label for a status key, e.g. for the status dropdown; "not_started"
// displays as "not reviewed" (renamed, data-owner request) instead of the literal key text.
export function statusFilterLabel(status: string): string {
  return status === 'not_started' ? 'not reviewed' : status.replace(/_/g, ' ');
}

export function formatDateTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return iso;
  }
}

export const REGION_DISPLAY_ORDER = ['AMR', 'AFR_EUR', 'HUBS', 'ASME', 'UNMAPPED'];

export function sortByRegionOrder<T extends { region_code: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const ai = REGION_DISPLAY_ORDER.indexOf(a.region_code);
    const bi = REGION_DISPLAY_ORDER.indexOf(b.region_code);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });
}

export interface RegionGroup<T> {
  regionCode: string;
  regionDisplayName: string;
  items: T[];
}

// Groups an already column/row-ordered list by region, preserving each item's original
// order within its group (purely presentational grouping, never a recalculation/resort).
export function groupByRegion<T extends { region_code: string; region_display_name: string }>(
  data: T[],
): RegionGroup<T>[] {
  const byCode = new Map<string, T[]>();
  for (const item of data) {
    const list = byCode.get(item.region_code);
    if (list) list.push(item);
    else byCode.set(item.region_code, [item]);
  }
  return REGION_DISPLAY_ORDER.filter((code) => byCode.has(code)).map((code) => ({
    regionCode: code,
    regionDisplayName: byCode.get(code)![0].region_display_name,
    items: byCode.get(code)!,
  }));
}
